<template>
	<div>
		<div style="display: flex;justify-content: space-between;">
			<div style="width: 400px" class="yl-flex flex_between">
				<Input placeholder="请输入姓名..." v-model="name" style="width: 300px">
				<i-button slot="append" icon="ios-search"></i-button>
				</Input>
				<Button class='ivu-btn-circle' type="primary" @click="resetClick">重置</Button>
			</div>
		</div>
		<div class="multiple">
			<div class="child-div">时间区间</div>
			<RadioGroup v-model="timePeriod">
				<Radio label="不限"><span>不限</span></Radio>
				<Radio label="今日"><span>今日</span></Radio>
				<Radio label="昨天"><span>昨天</span></Radio>
				<Radio label="最近7天"><span>最近7天</span></Radio>
				<Radio label="本月"><span>本月</span></Radio>
				<Radio label="上月"><span>上月</span></Radio>
				<Radio label="自定义"><span>自定义</span></Radio>
			</RadioGroup>
		</div>
		<div class="multiple">
			<div class="child-div">状态</div>
			<CheckboxGroup v-model="state">
				<Checkbox label="已入职"></Checkbox>
				<Checkbox label="未入职"></Checkbox>
			</CheckboxGroup>
		</div>
		<div class="multiple">
			<div class="child-div">通过司考</div>
			<RadioGroup v-model="passExam">
				<Radio label="不限"><span>不限</span></Radio>
				<Radio label="是"><span>是</span></Radio>
				<Radio label="否"><span>否</span></Radio>
			</RadioGroup>
		</div>

		<div style="margin-top: 30px;">
			<Table size="small" :columns="columns" ></Table>
		</div>
	</div>
</template>

<script>
	export default {
		name: "InterviewPass",
		data() {
			return {
				timePeriod: '不限', //时间区间
				state: [], //状态
                name:'',
				passExam: '不限',
				columns: [{
						title: '姓名',
						key: 'all',
						filters: [],
						filterMultiple: false,
						filterMethod(value, row) {

						}
					},
					{
						title: '性别',
						key: 'sex',
						filters: [{
								label: '男',
								value: 'man'
							},
							{
								label: '女',
								value: 'woman'
							},
						],
						filterMultiple: false,
						filterMethod(value, row) {

						}
					},
					{
						title:'电话',
						key:'phone'
					},
					{
						title: '应聘岗位',
						key: 'sex',
						filters: [
						],
						filterMultiple: false,
						filterMethod(value, row) {
					
						}
					},
					{
						title:'毕业院校',
						key:'school'
					},
					{
						title:'毕业时间',
						key:'graduateTime'
					},
					{
						title:'通过时间',
						key:'passTime'
					},
					{
						title:'计划到岗时间',
						key:'planTime'
					},
					{
						title:'学历',
						key:'education',
						filters: [
						],
						filterMultiple: false,
						filterMethod(value, row) {
											
						}
					},
					{
						title:'面试官',
						key:'interviewer'
					},
					{
						title:'意见',
						key:'opinion'
					},
					{
						title:'状态',
						key:'state'
					},
				]

			}
		},
		methods: {
			// 重置
			resetClick() {

			},
		
		}
	}
</script>

<style scoped lang="less">
	.yl-flex {
		display: flex;
		width: 300px;
		justify-content: space-between;
	}

	.multiple {
		display: flex;
		margin: 10px 0;
	}

	.child-div {
		text-align-last: justify;
		width: 70px;
		margin-right: 10px;
		color: #C1C1C2;
	}
</style>
